module.exports = "/img/_/_/_/assets/images/creeper/battle/common//29.jpg?9ff17173a96b1d172e5ee64082a73eed";